module.exports = __webpack_public_path__ + "abc27cffd03316e1ab0049f6682ba917.jpg";